export default {
  install (Vue, options) {
    let analytics = {}
    analytics.isCreated = false

    analytics.getGA = () => {
      ga('create', 'UA-38708089-4', 'auto')
      analytics.isCreated = true
      analytics.ga = ga
    }


    analytics.send = (eventCategory, eventAction, eventValue) => {
      if( eventCategory == void 0 || eventAction == void 0 ) {
        console.warn('eventCategory and eventAction needs to be defined')
        return
      }

      if( !analytics.isCreated ) {
        analytics.getGA()

        setTimeout( ()=>{
          if( eventValue === null ) {
            analytics.send( eventCategory, eventAction )
          }
          else {
            analytics.send( eventCategory, eventAction, eventValue )
          }
        }, 100)
        return
      }

      if( eventValue === void 0 ) {
        console.log('UA-38708089-4, eventCategory, eventAction', eventCategory, eventAction)
        analytics.ga('send', 'event', eventCategory, eventAction)
      }
      else {
        analytics.ga('send', 'event', eventCategory, eventAction, eventValue)
      }

      return
    }

    Vue.prototype.$ga = analytics
  }
}
